import { ResourcesConfig } from "aws-amplify";
import { RegionConfig } from "../types/AmplifyConfig";
import { Region, RegionKeys } from "../types/Region";

export const CognitoConfig = ({clientId, region}: {clientId?: string, region?: Region}) => {
  switch (region) {
    case RegionKeys.EU:
      return {
        region: import.meta.env.VITE_AUTH_REGION_EU,
        userPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID_EU,
        userPoolClientId: clientId || import.meta.env.VITE_AUTH_USER_POOL_WEB_CLIENT_ID_EU,
      };
    case RegionKeys.AU:
      return {
        region: import.meta.env.VITE_AUTH_REGION_AU,
        userPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID_AU,
        userPoolClientId: clientId || import.meta.env.VITE_AUTH_USER_POOL_WEB_CLIENT_ID_AU,
      };
    case RegionKeys.JP:
      return {
        region: import.meta.env.VITE_AUTH_REGION_JP,
        userPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID_JP,
        userPoolClientId: clientId || import.meta.env.VITE_AUTH_USER_POOL_WEB_CLIENT_ID_JP,
      };
    case RegionKeys.SG:
      return {
        region: import.meta.env.VITE_AUTH_REGION_SG,
        userPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID_SG,
        userPoolClientId: clientId || import.meta.env.VITE_AUTH_USER_POOL_WEB_CLIENT_ID_SG,
      };
    case RegionKeys.CA:
      return {
        region: import.meta.env.VITE_AUTH_REGION_CA,
        userPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID_CA,
        userPoolClientId: clientId || import.meta.env.VITE_AUTH_USER_POOL_WEB_CLIENT_ID_CA,
      };
    default:
      return {
        region: import.meta.env.VITE_AUTH_REGION_US,
        userPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID_US,
        userPoolClientId: clientId || import.meta.env.VITE_AUTH_USER_POOL_WEB_CLIENT_ID_US,
      };
  }
}

export const OAuthConfig = (region?: Region) => {
  switch (region) {
    case RegionKeys.EU:
      return {
        domain: import.meta.env.VITE_AUTH_USER_POOL_DOMAIN_EU,
      };
    case RegionKeys.AU:
      return {
        domain: import.meta.env.VITE_AUTH_USER_POOL_DOMAIN_AU,
      };
    case RegionKeys.JP:
      return {
        domain: import.meta.env.VITE_AUTH_USER_POOL_DOMAIN_JP,
      };
    case RegionKeys.SG:
      return {
        domain: import.meta.env.VITE_AUTH_USER_POOL_DOMAIN_SG,
      };
    case RegionKeys.CA:
      return {
        domain: import.meta.env.VITE_AUTH_USER_POOL_DOMAIN_CA,
      };
    default:
      return {
        domain: import.meta.env.VITE_AUTH_USER_POOL_DOMAIN_US,
      };
  }
}

export const AwsConfigAuth = (region: Region, config?: RegionConfig): ResourcesConfig => {
  return {
    Auth: {
      Cognito: {
        ...CognitoConfig({ clientId: config?.clientId, region: region }),
        loginWith: {
          oauth: {
            ...OAuthConfig(region),
            redirectSignIn: [import.meta.env.VITE_AUTH_REDIRECT_URI],
            redirectSignOut: [import.meta.env.VITE_AUTH_REDIRECT_URI],
            responseType: "code", // code | token
            scopes: ["openid", "email", "aws.cognito.signin.user.admin"],
          },
        }
      }
    }
  };
};